import Ticket from '../assets/img/ticket.png';
import ArrowDown from '../assets/img/dropdown.png';
import { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Hero = () => {
    const [glowOne, setGlowOne] = useState({
        x: 0,
        y: 0
    });
    const [glowTwo, setGlowTwo] = useState({
        x: 0,
        y: 0
    });
    const [glowThree, setGlowThree] = useState({
        x: 0,
        y: 0
    });

    useEffect(() => {
        AOS.init({ duration: 2000 });
    }, [])

    const handleHovering = (e) => {
        let new_y = (e.clientY * 4) / 150;
        let new_x = (e.clientX * 4) / 150;

        let new2_y = (e.clientY * 10) / 150;
        let new2_x = (e.clientX * 10) / 150;

        let new3_y = (e.clientY * 4) / 150;
        let new3_x = (e.clientX * 4) / 150;
        setGlowOne({x:new_x, y:new_y});
        setGlowTwo({x:new2_x, y:new2_y});
        setGlowThree({x:new3_x, y:new3_y});
    }
    return (
        <section className="Hero" id='Home' onMouseMove={(e)=>handleHovering(e)}>
            <img src={ArrowDown} alt="scrolldown" className="scrolldown__arrow" />
            <div className='glow1' style={{transform: `translate3d(${glowOne.x}px, ${glowOne.y}px, 0px`}}></div>
            <div className='glow2' style={{transform: `translate3d(${glowTwo.x}px, ${glowTwo.y}px, 0px`}}></div>
            <div>
                <h1 data-aos="fade-right">
                    NFTs - New, 
                    <br/> Fairer Ticketing.
                </h1>
                <p data-aos="zoom-in" data-aos-delay="300">An NFT ticketing marketplace enables individuals to issue event tickets and other collectible items as NFTs, enhancing connectivity between artists, fans, event planners, and brands to offer event participants a more complete experience.</p>
                <div className='foot__btn' data-aos="zoom-in" data-aos-delay="300">
                    <button>Litepaper</button>
                    <button>Join Us</button>
                </div>
            </div>
            <div data-aos="zoom-in">
                <img src={Ticket} alt="nftTicket" className='ticketnft' style={{transform: `translate3d(${glowThree.x}px, ${glowThree.y}px, 0px`}} />
            </div>
        </section>
    )
}

export default Hero;
